import { useHelpWizardStore } from '@/features/products/store/helpWizard';
import { type StepProps, type StepValue } from '@/features/products/types';

import { Box } from '@andritzot/metris-web-ui/layout/content/Box';

import HelpWizardCard from '../HelpWizardCard';
import { getStepOptionKey } from '../HelpDialog/utils';

const sortByValue = (a: { value: { value: string } }, b: { value: { value: string } }) =>
  a.value.value < b.value.value ? -1 : 1;

const renderButtons = (step: StepProps, addValues: (value: StepValue[]) => void) => {
  const { options, values } = step;
  const sortedOptions = [...(options ?? [])].sort(sortByValue);
  const selectedKeys = new Set(values.map(getStepOptionKey));

  const handleCardClick = (key: string) => {
    const nextKeys = selectedKeys.has(key) ? [...selectedKeys].filter((k) => k !== key) : [...selectedKeys, key];
    const nextValues = sortedOptions
      .filter((option) => nextKeys.includes(getStepOptionKey(option.value)))
      .map((option) => option.value);
    addValues(nextValues);
  };

  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', gap: 2, width: '100%' }}>
      {sortedOptions.map((option) => {
        const key = getStepOptionKey(option.value);
        const isSelected = selectedKeys.has(key);
        return (
          <HelpWizardCard
            key={key}
            title={option.value.value}
            tooltip={option.tooltip ?? ''}
            isSelected={isSelected}
            onClick={() => handleCardClick(key)}
          />
        );
      })}
    </Box>
  );
};

const Step = ({ index }: { index: number }) => {
  const steps = useHelpWizardStore((s) => s.steps);
  const step = steps[index];

  const addValues = (values: StepValue[]) => {
    const stepArr = steps.map((x, i) => (i === index ? { ...x, values } : x));
    useHelpWizardStore.setState({ steps: stepArr });
  };

  return step ? (
    <Box component="section" sx={{ width: '100%' }}>
      <h2>{step.title}</h2>
      <p>{step.content}</p>
      <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}>
        {renderButtons(step, addValues)}
      </Box>
    </Box>
  ) : null;
};

export default Step;
